module.exports = __webpack_public_path__ + "img/storage-1.39b3ffa4.webp";